import React from "react";

const assetsPath = process.env.PUBLIC_URL + "/assets/Numbers";

const sectionData = [
  {
    name: "Experienced Educators",
    description:
      "Our dedicated teachers support each student's potential in a caring environment.",
    icon: "icon1.svg",
  },
  {
    name: "Personalized Guidance",
    description: "Small class sizes ensure individual attention for every student.",
    icon: "icon2.svg",
  },
  {
    name: "Holistic Development",
    description:
      "We focus on academics, sports, arts, and community service for all-rounded growth.",
    icon: "icon3.svg",
  },
  {
    name: "Parent-School Partnership",
    description:
      "Open communication and collaboration for your child's growth.",
    icon: "icon4.svg",
  },
  {
    name: "Modern Facilities",
    description:
      "State-of-the-art classrooms and labs enhance the learning experience.",
    icon: "icon5.svg",
  },
  {
    name: "Safe and Inclusive Environment",
    description:
      "A respectful culture where every student is valued.",
    icon: "icon6.svg",
  },
  {
    name: "Academic Excellence",
    description:
      "High standards and opportunities for your child's success.",
    icon: "icon7.svg",
  },
  {
    name: "Engaging Teaching Methods",
    description:
      "Innovative approaches for critical thinking and problem-solving.",
    icon: "icon8.svg",
  },
  {
    name: "Successful Alumni",
    description:
      "Our graduates excel in various fields, reflecting the quality of our education.",
    icon: "icon9.svg",
  },
  {
    name: "Community Service",
    description:
      "Promoting social responsibility through meaningful involvement.",
    icon: "icon10.svg",
  },
];

const WhyChooseUs = () => {
  return (
    <div className="bg-sky-600 flex flex-col items-center px-5 pt-5 pb-2 max-md:px-5">
      <div className="text-white text-5xl mb-5 font-black tracking-[3.2px] capitalize  max-md:max-w-full max-md:text-4xl text-center">
        WHY CHOOSE US?
      </div>
      <div className="self-stretch mt-5 max-md:w-full">
        <div className="gap-5 flex flex-wrap max-md:flex-col max-md:items-stretch max-md:gap-0">
          {sectionData.map((section, index) => (
            <div key={index} className="flex flex-col items-stretch w-[30%] max-md:w-full max-md:ml-0 mx-auto mb-5 max-md:mb-0">
              <div className="flex flex-col items-stretch max-md:mt-10">
                <div className="mx-auto">
                  <img
                    loading="lazy"
                    src={`${assetsPath}/${section.icon}`}
                    className="aspect-square object-contain object-center w-[30px]"
                  />
                </div>
                <div className="text-white text-xl font-bold tracking-wider grow whitespace-nowrap mt-2 text-center">
                  {section.name}
                </div>
                <div className="text-white text-center  text-base tracking-wider self-center w-full max-md:w-[241px] mt-1">
                  {section.description}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default WhyChooseUs;
